import React, { useEffect } from "react"
import { Heading3 } from "../typography/headings"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { useTranslation } from "react-i18next"
import { translationKeys } from "../../util/translationKeys"
import { THIRTYSECONDS } from "../../util/sizeUtils"
import { ButtonAction } from "../button/ButtonAction"
import { trackDatadogAction } from "../../services/datadog-rum"

export const PaymentLoader = () => {
  const { t } = useTranslation()
  const [showRefreshButton, setShowRefreshButton] = React.useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowRefreshButton(true)
    }, THIRTYSECONDS)
    return () => clearTimeout(timeout)
  })

  return (
    <div className="flex flex-col items-center justify-center w-screen h-[80vh] bg-backgroundBranded gap-6">
      <div className="flex flex-col w-[72px] h-[72px] items-center justify-center bg-ctaLight rounded-full text-ctaMain">
        <Heading3>
          <FontAwesomeIcon icon={solid("spinner")} spin pulse />
        </Heading3>
      </div>
      <Heading3 className="text-foreground-base">
        {t(translationKeys.comboOrderProcessing)}...
      </Heading3>
      {showRefreshButton && (
        <ButtonAction
          className="w-[300px] mt-16"
          size="large"
          onClick={async () => {
            // The payment timeout never resolved and the user is retrying by
            // hand - a funnel signal rather than an exception
            trackDatadogAction("payment_loader_manual_refresh")
            window.location.reload()
          }}
        >
          {t(translationKeys.paymentComboTimoutCtaTitle)}
        </ButtonAction>
      )}
    </div>
  )
}
